"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ALL_INVENTORY_PERMISSIONS = exports.InventoryPermissions = void 0;
/**
 * Permission string catalog for Inventory (Stage 14, Phase 2 — Pharmacy
 * Procurement & Inventory Engine). Step 2a: `StockLocation`. Step 2b:
 * `StockBatch`/`StockLedgerEntry` (originally read-only; Enterprise
 * Pharmacy Architecture Revision 2 Phase 2 — Batch Lifecycle — added the
 * first manual `StockBatch` status mutations, see
 * `STOCK_BATCH_MANAGE_LIFECYCLE`/`STOCK_BATCH_DISPOSE` below). Step 2c:
 * `StockAdjustment`/`StockTransfer` — the first manual, quantity-mutating
 * actions.
 */
exports.InventoryPermissions = {
    STOCK_LOCATION_READ: 'stock-location:read',
    STOCK_LOCATION_MANAGE: 'stock-location:manage',
    STOCK_BATCH_READ: 'stock-batch:read',
    // Phase 2 (Batch Lifecycle) — the first manual StockBatch mutations
    // (quarantine/flagQuality/block/recall/release/confirmAvailable are
    // status-only, no ledger effect; DISPOSE is separate because it's the
    // one transition that also moves quantity via StockLedgerService,
    // matching STOCK_ADJUSTMENT_POST's own separation from lower-risk
    // status changes).
    STOCK_BATCH_MANAGE_LIFECYCLE: 'stock-batch:manage-lifecycle',
    STOCK_BATCH_DISPOSE: 'stock-batch:dispose',
    STOCK_LEDGER_READ: 'stock-ledger:read',
    STOCK_ADJUSTMENT_READ: 'stock-adjustment:read',
    STOCK_ADJUSTMENT_CREATE: 'stock-adjustment:create',
    STOCK_ADJUSTMENT_APPROVE: 'stock-adjustment:approve',
    STOCK_ADJUSTMENT_POST: 'stock-adjustment:post',
    STOCK_ADJUSTMENT_CANCEL: 'stock-adjustment:cancel',
    STOCK_TRANSFER_READ: 'stock-transfer:read',
    STOCK_TRANSFER_CREATE: 'stock-transfer:create',
    STOCK_TRANSFER_DISPATCH: 'stock-transfer:dispatch',
    STOCK_TRANSFER_RECEIVE: 'stock-transfer:receive',
    STOCK_TRANSFER_CANCEL: 'stock-transfer:cancel',
    // Inventory Movement System — Transfer Tab Upgrade. MOVEMENT_TYPE_*
    // gates the admin-configurable Movement Type Master; INVENTORY_MOVEMENT_*
    // gates the transactional aggregate that supersedes StockTransfer's
    // role for every non-purchase/non-sale movement going forward.
    MOVEMENT_TYPE_READ: 'movement-type:read',
    MOVEMENT_TYPE_MANAGE: 'movement-type:manage',
    INVENTORY_MOVEMENT_READ: 'inventory-movement:read',
    INVENTORY_MOVEMENT_CREATE: 'inventory-movement:create',
    INVENTORY_MOVEMENT_UPDATE: 'inventory-movement:update',
    INVENTORY_MOVEMENT_SUBMIT: 'inventory-movement:submit',
    INVENTORY_MOVEMENT_APPROVE: 'inventory-movement:approve',
    INVENTORY_MOVEMENT_DISPATCH: 'inventory-movement:dispatch',
    INVENTORY_MOVEMENT_RECEIVE: 'inventory-movement:receive',
    INVENTORY_MOVEMENT_POST: 'inventory-movement:post',
    INVENTORY_MOVEMENT_CANCEL: 'inventory-movement:cancel',
    // Return workflow overhaul — a ward returning unused stock back to the
    // original batch it was issued from (distinct from `pharmacy-sale:return`,
    // which covers a customer/patient return against a billed sale line).
    INVENTORY_MOVEMENT_RETURN: 'inventory-movement:return',
    // Reorder Level — per drug, per store threshold + the below-threshold
    // suggestion list feeding the Store->Pharmacy / Vendor->Hospital
    // reorder flows. MANAGE covers create/update/delete of the threshold
    // itself; the suggestion list read is gated on READ (same as viewing
    // any other stock data).
    REORDER_LEVEL_READ: 'reorder-level:read',
    REORDER_LEVEL_MANAGE: 'reorder-level:manage',
};
exports.ALL_INVENTORY_PERMISSIONS = Object.values(exports.InventoryPermissions);
//# sourceMappingURL=inventory.permissions.js.map